// extracted by mini-css-extract-plugin
module.exports = {"divider":"WorkbenchPage_divider__2b10o","root":"WorkbenchPage_root__aU2RD","panel":"WorkbenchPage_panel__1WDDf"};